import React from 'react';
import AssetImages from '../constants/images';
import '../constants/AssetsCss';
import GetORPostAsync from '../constants/restservice';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import withRouter from '../constants/withRouter';

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.onsponsorIDChange = this.onsponsorIDChange.bind(this);
        this.onfullnameChange = this.onfullnameChange.bind(this);
        this.onemailChange = this.onemailChange.bind(this);
        this.oncountryChange = this.oncountryChange.bind(this);
        this.oncityChange = this.oncityChange.bind(this);
        this.onmobileChange = this.onmobileChange.bind(this);
        this.onpasswordChange = this.onpasswordChange.bind(this);
        this.onconfirmPasswordChange = this.onconfirmPasswordChange.bind(this);
        this.ontermsAndConditionsChange = this.ontermsAndConditionsChange.bind(this);
        this.onpositionChange = this.onpositionChange.bind(this);
        this.handleKeypress = this.handleKeypress.bind(this);
        this.onRegister = this.onRegister.bind(this);
        this.onCheckUsername = this.onCheckUsername.bind(this);
        this.state = {
            sponsorID: "",
            fullname: "",
            email: "",
            country: "India",
            city: "",
            mobile: "",
            password: "",
            confirmPassword: "",
            termsAndConditions: false,
            selectedpos: "",
            sponsorName: "",
            showpassword: false,
            showtpassword: false,
            tpassword: "",
            confirmtPassword: "",
            aadhar: "",
            pan: "",


        };
    }
    componentDidMount() {
        if (this.props.history.location.state) {
            this.setState({
                sponsorID: this.props.history.location.state.sponsorID,
                selectedpos: this.props.history.location.state.selectedpos,
            });
        }
        if (this.props.history.params.ref) {
            if (this.props.history.params.ref.includes('&')) {
                let a = this.props.history.params.ref.split('&');
                this.setState({
                    sponsorID: a[0].replace(':', ''),
                    selectedpos: a[1]
                });
                this.onCheckUsername(a[0].replace(':', ''));
            } else {
                this.setState({
                    sponsorID: this.props.history.params.ref.replace(':', '')
                });
                this.onCheckUsername(this.props.history.params.ref.replace(':', ''));
            }

        }
    }
    handleKeypress(e) {
        //it triggers by pressing the enter key
        if (e.key === "Enter") {
            this.onRegister();
        }
    };
    async onRegister() {
        if (!this.validate()) {
            return;
        }
        let jsondata = {
            SponsorID: this.state.sponsorID,
            FirstName: this.state.fullname,
            Email: this.state.email,
            email: this.state.email,
            Country: this.state.country,
            City: this.state.city,
            mobile: this.state.mobile,
            Password: this.state.password,
            tpassword: this.state.tpassword,
            selectedpos: this.state.selectedpos,
            aadhar: this.state.aadhar,
            pan: this.state.pan,


        };
        // let res = await GetORPostAsync("send_otp_signup.asp", "POST", JSON.stringify(jsondata));
        // if (res.status === "error") {
        //     toast.error(res.message);
        //     return;
        // }
        // toast.success(res.message);
        // Swal.fire({
        //     title: 'OTP Verification',
        //     html: `<input type="text" id="login" class="form-control" placeholder="Enter your OTP here"></input>`,
        //     confirmButtonText: 'Submit',
        //     focusConfirm: false,
        //     background: '#262625',
        //     preConfirm: async () => {
        //         const login = Swal.getPopup().querySelector('#login').value
        //         if (!login) {
        //             Swal.showValidationMessage(`Enter OTP`);
        //             return;
        //         }
        //         jsondata.otp = login;
        let response = await GetORPostAsync('actReg.asp', 'POST', JSON.stringify(jsondata));
        if (response.status == 'error') {
            Swal.showValidationMessage(response.message);
            return;
        }
        toast(response.message);
        await Swal.fire({
            title: "Registered Successfully",
            text: "Don't forget to note your username : " + response.memberid,
            icon: "success"
        });
        this.props.history.goBack();
        //     }
        // })

    }
    async onCheckUsername(refid) {
        let res = await GetORPostAsync("checkusername.asp", "POST", JSON.stringify({ username: refid }));
        if (res.status === "success") {
            toast("Sponsorid not available");
            return;
        }
        this.setState({
            sponsorName: res.fullname
        })
    }
    onsponsorIDChange(event) {
        this.setState({ sponsorID: event.target.value });
    }
    onfullnameChange(event) {
        this.setState({ fullname: event.target.value });
    }
    onemailChange(event) {
        this.setState({ email: event.target.value });
    }
    oncountryChange(event) {
        this.setState({ country: event.target.value });
    }
    oncityChange(event) {
        this.setState({ city: event.target.value });
    }
    onmobileChange(event) {
        this.setState({ mobile: event.target.value });
    }
    onpasswordChange(event) {
        this.setState({ password: event.target.value });
    }
    onconfirmPasswordChange(event) {
        this.setState({ confirmPassword: event.target.value });
    }
    onpositionChange(event) {
        this.setState({ selectedpos: event.target.value });
    }
    ontermsAndConditionsChange(event) {
        this.setState({ termsAndConditions: event.target.value });
    }
    checkValidPan(panno) {
        if (panno.length !== 10) {
            return false;
        }
        let startstr = panno.substring(0, 5);
        let middlestr = panno.substring(5, 9);
        let endstr = panno.substring(panno.length - 1);
        if (Number(startstr)) {
            return false;
        }
        if (!Number(middlestr)) {
            return false;
        }
        if (Number(endstr)) {
            return false;
        }
        return true;
    }
    validate() {
        let isValid = false;
        if (!this.state.sponsorID) {
            toast("Enter valid sponsorID");
        } else if (!this.state.fullname) {
            toast("Enter valid fullname");
        } else if (!/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.email)) {
            toast("Enter valid email");
        } else if (!this.state.country) {
            toast("Enter valid country");
        } else if (!this.state.city) {
            toast("Enter valid city");
        } else if (!this.state.mobile) {
            toast("Enter valid mobile");
        } else if (!this.state.password) {
            toast("Enter valid password");
        } else if (!this.state.confirmPassword) {
            toast("Enter valid confirm password");
        } else if (!this.state.tpassword) {
            toast("Enter valid transaction password");
        } else if (!this.state.confirmtPassword) {
            toast("Enter valid confirm transaction password");
        } else if (this.state.password !== this.state.confirmPassword) {
            toast("Password Mismatched");
        } else if (this.state.tpassword !== this.state.confirmtPassword) {
            toast("Transaction Password Mismatched");
        } else if (!this.state.aadhar || this.state.aadhar.length !== 12) {
            toast("Enter valid aadhar number");
        } else if (!this.state.pan || !this.checkValidPan(this.state.pan)) {
            toast("Enter valid pan number");
        } else if (!this.state.termsAndConditions) {
            toast("Please Accept our terms and conditions");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    render() {
        return (
            <div className="page-content login-div" style={{ height: '100%', alignItems: 'center', flexDirection: 'row' }}>
                <div className="content-wrapper " style={{ backgroundColor: "rgb(0 0 0 / 68%)", padding: 10 }}>
                    <div className="content d-flex justify-content-center align-items-center">
                        <div className="login-form">
                            <div className="card" style={{ background: "#2f2f2f" }}>
                                <div className="card-body  mb-4">
                                    <div className="text-center mb-3">
                                        <div className='card' style={{ backgroundColor: "#1b1b1b" }}>
                                            <div className="card-body">
                                                <img src={AssetImages.logo} alt="img" className="" />
                                            </div>
                                        </div>
                                        <div class="login-separater text-center mb-4"> <span>Account Registration</span><hr /></div>
                                    </div>
                                    <div className='pt-5'>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user inputicon"></i>
                                                <input onBlur={(e) => {
                                                    this.onCheckUsername(this.state.sponsorID);
                                                }} style={{ border: 0, marginTop: 2 }} className="form-control" name="SponsorID" id="SponsorID" placeholder="Sponsor ID" type="text" onChange={this.onsponsorIDChange} value={this.state.sponsorID} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user-tag inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} className="form-control" name="Sponsorname" id="Sponsorname" placeholder="Sponsor Name" type="text" value={this.state.sponsorName} readOnly />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <label style={{ float: "left", fontSize: 14, fontWeight: 'bold' }}>Position</label>
                                            <div className="row">
                                                <label className="custom-control custom-radio ml-auto">
                                                    <input type="radio" className="custom-control-input" name="example-radios" value="Left" checked={this.state.selectedpos === "Left"} onChange={this.onpositionChange} />
                                                    <span className="custom-control-label">Left</span>
                                                </label>
                                                <label className="custom-control custom-radio ml-2">
                                                    <input type="radio" className="custom-control-input" name="example-radios" value="Right" checked={this.state.selectedpos === "Right"} onChange={this.onpositionChange} />
                                                    <span className="custom-control-label">Right</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type="text" className="form-control" id="FirstName" name="FirstName" placeholder="Full name" onChange={this.onfullnameChange} value={this.state.fullname} />
                                            </div>
                                        </div>

                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-envelope inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type="email" className="form-control" id="Email" name="Email" placeholder="Email" onChange={this.onemailChange} value={this.state.email} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-flag inputicon"></i>
                                                <select style={{ border: 0, marginTop: 2 }} className="form-control " id="Country" name="Country" onChange={this.oncountryChange} value={this.state.country}>
                                                    <option value="">	-- Select Country --	</option>
                                                    <option value="Afghanistan">	Afghanistan	</option>
                                                    <option value="Albania">	Albania	</option>
                                                    <option value="Algeria">	Algeria	</option>
                                                    <option value="Andorra">	Andorra	</option>
                                                    <option value="Angola">	Angola	</option>
                                                    <option value="Anguilla">	Anguilla	</option>
                                                    <option value="Antigua - Barbuda">	Antigua - Barbuda	</option>
                                                    <option value="Argentina">	Argentina	</option>
                                                    <option value="Armenia">	Armenia	</option>
                                                    <option value="Australia" selected="">	Australia	</option>
                                                    <option value="Austria">	Austria	</option>
                                                    <option value="Azerbaijan">	Azerbaijan	</option>
                                                    <option value="Bahamas">	Bahamas	</option>
                                                    <option value="Bahrain">	Bahrain	</option>
                                                    <option value="Bangladesh">	Bangladesh	</option>
                                                    <option value="Barbados">	Barbados	</option>
                                                    <option value="Belarus">	Belarus	</option>
                                                    <option value="Belgium">	Belgium	</option>
                                                    <option value="Belize">	Belize	</option>
                                                    <option value="Benin">	Benin	</option>
                                                    <option value="Bermuda">	Bermuda	</option>
                                                    <option value="Bhutan">	Bhutan	</option>
                                                    <option value="Bolivia">	Bolivia	</option>
                                                    <option value="Bosnia - Herzegovina">	Bosnia - Herzegovina	</option>
                                                    <option value="Botswana">	Botswana	</option>
                                                    <option value="Brazil">	Brazil	</option>
                                                    <option value="Brunei Darussalam">	Brunei Darussalam	</option>
                                                    <option value="Bulgaria">	Bulgaria	</option>
                                                    <option value="Burkina Faso">	Burkina Faso	</option>
                                                    <option value="Myanmar/Burma">	Myanmar/Burma	</option>
                                                    <option value="Burundi">	Burundi	</option>
                                                    <option value="Cambodia">	Cambodia	</option>
                                                    <option value="Cameroon">	Cameroon	</option>
                                                    <option value="Canada">	Canada	</option>
                                                    <option value="Cape Verde">	Cape Verde	</option>
                                                    <option value="Cayman Islands">	Cayman Islands	</option>
                                                    <option value="Central African Republic">	Central African Republic	</option>
                                                    <option value="Chad">	Chad	</option>
                                                    <option value="Chile">	Chile	</option>
                                                    <option value="China">	China	</option>
                                                    <option value="Colombia">	Colombia	</option>
                                                    <option value="Comoros">	Comoros	</option>
                                                    <option value="Congo">	Congo	</option>
                                                    <option value="Costa Rica">	Costa Rica	</option>
                                                    <option value="Croatia">	Croatia	</option>
                                                    <option value="Cuba">	Cuba	</option>
                                                    <option value="Cyprus">	Cyprus	</option>
                                                    <option value="Czech Republic">	Czech Republic	</option>
                                                    <option value="Democratic Republic of the Congo">	Democratic Republic of the Congo	</option>
                                                    <option value="Denmark">	Denmark	</option>
                                                    <option value="Djibouti">	Djibouti	</option>
                                                    <option value="Dominica">	Dominica	</option>
                                                    <option value="Dominican Republic">	Dominican Republic	</option>
                                                    <option value="Ecuador">	Ecuador	</option>
                                                    <option value="Egypt">	Egypt	</option>
                                                    <option value="El Salvador">	El Salvador	</option>
                                                    <option value="Equatorial Guinea">	Equatorial Guinea	</option>
                                                    <option value="Eritrea">	Eritrea	</option>
                                                    <option value="Estonia">	Estonia	</option>
                                                    <option value="Ethiopia">	Ethiopia	</option>
                                                    <option value="Fiji">	Fiji	</option>
                                                    <option value="Finland">	Finland	</option>
                                                    <option value="France">	France	</option>
                                                    <option value="French Guiana">	French Guiana	</option>
                                                    <option value="Gabon">	Gabon	</option>
                                                    <option value="Gambia">	Gambia	</option>
                                                    <option value="Georgia">	Georgia	</option>
                                                    <option value="Germany">	Germany	</option>
                                                    <option value="Ghana">	Ghana	</option>
                                                    <option value="Great Britain">	Great Britain	</option>
                                                    <option value="Greece">	Greece	</option>
                                                    <option value="Grenada">	Grenada	</option>
                                                    <option value="Guadeloupe">	Guadeloupe	</option>
                                                    <option value="Guatemala">	Guatemala	</option>
                                                    <option value="Guinea">	Guinea	</option>
                                                    <option value="Guinea-Bissau">	Guinea-Bissau	</option>
                                                    <option value="Guyana">	Guyana	</option>
                                                    <option value="Haiti">	Haiti	</option>
                                                    <option value="Honduras">	Honduras	</option>
                                                    <option value="Hungary">	Hungary	</option>
                                                    <option value="Iceland">	Iceland	</option>
                                                    <option value="India">	India	</option>
                                                    <option value="Indonesia">	Indonesia	</option>
                                                    <option value="Iran">	Iran	</option>
                                                    <option value="Iraq">	Iraq	</option>
                                                    <option value="Israel and the Occupied Territories">	Israel and the Occupied Territories	</option>
                                                    <option value="Italy">	Italy	</option>
                                                    <option value="Ivory Coast (Cote d-Ivoire)">	Ivory Coast (Cote d-Ivoire)	</option>
                                                    <option value="Jamaica">	Jamaica	</option>
                                                    <option value="Japan">	Japan	</option>
                                                    <option value="Jordan">	Jordan	</option>
                                                    <option value="Kazakhstan">	Kazakhstan	</option>
                                                    <option value="Kenya">	Kenya	</option>
                                                    <option value="Kosovo">	Kosovo	</option>
                                                    <option value="Kuwait">	Kuwait	</option>
                                                    <option value="Kyrgyz Republic (Kyrgyzstan)">	Kyrgyz Republic (Kyrgyzstan)	</option>
                                                    <option value="Laos">	Laos	</option>
                                                    <option value="Latvia">	Latvia	</option>
                                                    <option value="Lebanon">	Lebanon	</option>
                                                    <option value="Lesotho">	Lesotho	</option>
                                                    <option value="Liberia">	Liberia	</option>
                                                    <option value="Libya">	Libya	</option>
                                                    <option value="Liechtenstein">	Liechtenstein	</option>
                                                    <option value="Lithuania">	Lithuania	</option>
                                                    <option value="Luxembourg">	Luxembourg	</option>
                                                    <option value="Republic of Macedonia">	Republic of Macedonia	</option>
                                                    <option value="Madagascar">	Madagascar	</option>
                                                    <option value="Malawi">	Malawi	</option>
                                                    <option value="Malaysia">	Malaysia	</option>
                                                    <option value="Maldives">	Maldives	</option>
                                                    <option value="Mali">	Mali	</option>
                                                    <option value="Malta">	Malta	</option>
                                                    <option value="Martinique">	Martinique	</option>
                                                    <option value="Mauritania">	Mauritania	</option>
                                                    <option value="Mauritius">	Mauritius	</option>
                                                    <option value="Mayotte">	Mayotte	</option>
                                                    <option value="Mexico">	Mexico	</option>
                                                    <option value="Moldova">	Moldova 	</option>
                                                    <option value="Monaco">	Monaco	</option>
                                                    <option value="Mongolia">	Mongolia	</option>
                                                    <option value="Montenegro">	Montenegro	</option>
                                                    <option value="Montserrat">	Montserrat	</option>
                                                    <option value="Morocco">	Morocco	</option>
                                                    <option value="Mozambique">	Mozambique	</option>
                                                    <option value="Namibia">	Namibia	</option>
                                                    <option value="Nepal">	Nepal	</option>
                                                    <option value="Netherlands">	Netherlands	</option>
                                                    <option value="New Zealand">	New Zealand	</option>
                                                    <option value="Nicaragua">	Nicaragua	</option>
                                                    <option value="Niger">	Niger	</option>
                                                    <option value="Nigeria">	Nigeria	</option>
                                                    <option value="Korea, Democratic Republic of (North Korea)">	Korea, Democratic Republic of (North Korea) 	</option>
                                                    <option value="Norway">	Norway	</option>
                                                    <option value="Oman">	Oman	</option>
                                                    <option value="Pacific Islands">	Pacific Islands	</option>
                                                    <option value="Pakistan">	Pakistan	</option>
                                                    <option value="Panama">	Panama	</option>
                                                    <option value="Papua New Guinea">	Papua New Guinea	</option>
                                                    <option value="Paraguay">	Paraguay	</option>
                                                    <option value="Peru">	Peru	</option>
                                                    <option value="Philippines">	Philippines	</option>
                                                    <option value="Poland">	Poland	</option>
                                                    <option value="Portugal">	Portugal	</option>
                                                    <option value="Puerto Rico">	Puerto Rico	</option>
                                                    <option value="Qatar">	Qatar	</option>
                                                    <option value="Reunion">	Reunion	</option>
                                                    <option value="Romania">	Romania	</option>
                                                    <option value="Russian Federation">	Russian Federation	</option>
                                                    <option value="Rwanda">	Rwanda	</option>
                                                    <option value="Saint Kitts and Nevis">	Saint Kitts and Nevis	</option>
                                                    <option value="Saint Lucia">	Saint Lucia	</option>
                                                    <option value="Saint Vincent-s - Grenadines">	Saint Vincent-s - Grenadines	</option>
                                                    <option value="Samoa">	Samoa	</option>
                                                    <option value="Sao Tome and Principe">	Sao Tome and Principe	</option>
                                                    <option value="Saudi Arabia">	Saudi Arabia	</option>
                                                    <option value="Senegal">	Senegal	</option>
                                                    <option value="Serbia">	Serbia	</option>
                                                    <option value="Seychelles">	Seychelles	</option>
                                                    <option value="Sierra Leone">	Sierra Leone	</option>
                                                    <option value="Singapore">	Singapore	</option>
                                                    <option value="Slovak Republic (Slovakia)">	Slovak Republic (Slovakia)	</option>
                                                    <option value="Slovenia">	Slovenia	</option>
                                                    <option value="Solomon Islands">	Solomon Islands	</option>
                                                    <option value="Somalia">	Somalia	</option>
                                                    <option value="South Africa">	South Africa	</option>
                                                    <option value="Korea, Republic of (South Korea)">	Korea, Republic of (South Korea)	</option>
                                                    <option value="South Sudan">	South Sudan	</option>
                                                    <option value="Spain">	Spain	</option>
                                                    <option value="Sri Lanka">	Sri Lanka	</option>
                                                    <option value="Sudan">	Sudan	</option>
                                                    <option value="Suriname">	Suriname	</option>
                                                    <option value="Swaziland">	Swaziland	</option>
                                                    <option value="Sweden">	Sweden	</option>
                                                    <option value="Switzerland">	Switzerland	</option>
                                                    <option value="Syria">	Syria	</option>
                                                    <option value="Tajikistan">	Tajikistan	</option>
                                                    <option value="Tanzania">	Tanzania	</option>
                                                    <option value="Thailand">	Thailand	</option>
                                                    <option value="Timor Leste">	Timor Leste	</option>
                                                    <option value="Togo">	Togo	</option>
                                                    <option value="Trinidad - Tobago">	Trinidad - Tobago	</option>
                                                    <option value="Tunisia">	Tunisia	</option>
                                                    <option value="Turkey">	Turkey	</option>
                                                    <option value="Turkmenistan">	Turkmenistan	</option>
                                                    <option value="Turks - Caicos Islands">	Turks - Caicos Islands	</option>
                                                    <option value="Uganda">	Uganda	</option>
                                                    <option value="Ukraine">	Ukraine	</option>
                                                    <option value="United Arab Emirates">	United Arab Emirates	</option>
                                                    <option value="United States of America (USA)">	United States of America (USA)	</option>
                                                    <option value="Uruguay">	Uruguay	</option>
                                                    <option value="Uzbekistan">	Uzbekistan	</option>
                                                    <option value="Venezuela">	Venezuela	</option>
                                                    <option value="Vietnam">	Vietnam	</option>
                                                    <option value="Virgin Islands (UK)">	Virgin Islands (UK)	</option>
                                                    <option value="Virgin Islands (US)">	Virgin Islands (US)	</option>
                                                    <option value="Yemen">	Yemen	</option>
                                                    <option value="Zambia">	Zambia	</option>
                                                    <option value="Zimbabwe">	Zimbabwe	</option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-home inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type="text" className="form-control" id="City" name="City" placeholder="City" onChange={this.oncityChange} value={this.state.city} />
                                            </div>
                                        </div>

                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-phone inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type="text" className="form-control" id="mobile" name="mobile" placeholder="Hand Phone" onChange={this.onmobileChange} value={this.state.mobile} />
                                            </div>
                                        </div>


                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-lock inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={!this.state.showpassword ? "password" : "text"} className="form-control" id="Password" name="Password" placeholder="Password" onChange={this.onpasswordChange} value={this.state.password} />
                                                <i className={`las la-eye${!this.state.showpassword ? "" : "-slash"} inputicon`} onClick={(e) => {
                                                    this.setState({
                                                        showpassword: !this.state.showpassword
                                                    })
                                                }}></i>
                                            </div>
                                        </div>

                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-lock inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={!this.state.showpassword ? "password" : "text"} onKeyPress={this.handleKeypress} className="form-control" id="ConfirmPassword" name="ConfirmPassword" placeholder="Confirm password" onChange={this.onconfirmPasswordChange} value={this.state.confirmPassword} />
                                                <i className={`las la-eye${!this.state.showpassword ? "" : "-slash"} inputicon`} onClick={(e) => {
                                                    this.setState({
                                                        showpassword: !this.state.showpassword
                                                    })
                                                }}></i>
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-lock inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={!this.state.showtpassword ? "password" : "text"} className="form-control" id="TransactionPassword" name="TransactionPassword" placeholder="Transaction Password" onChange={(e) => {
                                                    this.setState({
                                                        tpassword: e.target.value
                                                    })
                                                }} value={this.state.tpassword} />
                                                <i className={`las la-eye${!this.state.showtpassword ? "" : "-slash"} inputicon`} onClick={(e) => {
                                                    this.setState({
                                                        showtpassword: !this.state.showtpassword
                                                    })
                                                }}></i>
                                            </div>
                                        </div>

                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-lock inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={!this.state.showtpassword ? "password" : "text"} className="form-control" id="ConfirmtPassword" name="ConfirmtPassword" placeholder="Confirm Transaction password" onChange={(e) => {
                                                    this.setState({
                                                        confirmtPassword: e.target.value
                                                    })
                                                }} value={this.state.confirmtPassword} />
                                                <i className={`las la-eye${!this.state.showtpassword ? "" : "-slash"} inputicon`} onClick={(e) => {
                                                    this.setState({
                                                        showtpassword: !this.state.showtpassword
                                                    })
                                                }}></i>
                                            </div>
                                        </div>

                                        {/* ------- */}

                                        {/* <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="holdername" name="holdername" placeholder="Account Holder Name" onChange={(e) => {
                                                    this.setState({
                                                        checkname: e.target.value
                                                    })
                                                }} value={this.state.checkname} />
                                            </div>
                                        </div> */}
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-id-card inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="aadhar" name="aadhar" placeholder="Aadhar" onChange={(e) => {
                                                    this.setState({
                                                        aadhar: e.target.value
                                                    })
                                                }} value={this.state.aadhar} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-address-card inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="pan" name="pan" placeholder="PAN" onChange={(e) => {
                                                    this.setState({
                                                        pan: e.target.value
                                                    })
                                                }} value={this.state.pan} />
                                            </div>
                                        </div>
                                        {/* <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-credit-card inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="accountnumber" name="accountnumber" placeholder="Account Number" onChange={(e) => {
                                                    this.setState({
                                                        account_number: e.target.value
                                                    })
                                                }} value={this.state.account_number} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-sim-card inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="IFSC" name="IFSC" placeholder="IFSC" onChange={(e) => {
                                                    this.setState({
                                                        ifsc: e.target.value
                                                    })
                                                }} value={this.state.ifsc} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-university inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="Bankname" name="Bankname" placeholder="Bank Name" onChange={(e) => {
                                                    this.setState({
                                                        bank_name: e.target.value
                                                    })
                                                }} value={this.state.bank_name} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-city inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="branchname" name="branchname" placeholder="Branch name" onChange={(e) => {
                                                    this.setState({
                                                        branch_name: e.target.value
                                                    })
                                                }} value={this.state.branch_name} />
                                            </div>
                                        </div> */}
                                        {/* <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user inputicon"></i>
                                                <input style={{ border: 0, marginTop: 2 }} type={"text"} className="form-control" id="nomineename" name="nomineename" placeholder="Nominee Name" onChange={(e) => {
                                                    this.setState({
                                                        nmname: e.target.value
                                                    })
                                                }} value={this.state.nmname} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user-tie inputicon"></i>
                                                <select style={{ border: 0, marginTop: 2 }} className='form-control' onChange={(e) => {
                                                    this.setState({
                                                        nmrelation: e.target.value
                                                    })
                                                }} value={this.state.nmrelation} >
                                                    <option value={""}>-- Select Nominee Relationship --</option>
                                                    <option value="Father">Father</option>
                                                    <option value="Wife">Wife</option>
                                                    <option value="Husband">Husband</option>
                                                    <option value="Mother">Mother</option>
                                                    <option value="Brother">Brother</option>
                                                    <option value="Sister">Sister</option>
                                                    <option value="Son">Son</option>
                                                    <option value="Daughter">Daughter</option>
                                                </select>
                                            </div>
                                        </div> */}

                                    </div>
                                    <div className="form-group d-flex align-items-center">
                                        <div className="uniform-checker"><span className="checked"><input className="form-input-styled" id="AgreeTerms" name="AgreeTerms" type="checkbox" onChange={this.ontermsAndConditionsChange} value={this.state.termsAndConditions} />  I agree to the General terms &amp; conditions</span></div>
                                    </div>

                                    <div className="form-group">
                                        <button type="button" onClick={this.onRegister} className="btn btn-primary btn-block">Sign Up <i className="icon-circle-right2 ml-2"></i></button>
                                    </div>
                                    <div className="form-group text-center content-divider">
                                        <span className="px-2">Already have an account?</span>
                                    </div>
                                    <div className="form-group">
                                        <Link to="/" className="btn btn-light btn-block">Sign In</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Register);